import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Calendar, User, Clock } from "lucide-react";
import api from "@/lib/api";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

export default function ArtikelDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/articles/${id}`)
      .then((res) => setArticle(res.data))
      .catch(() => setArticle(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ paddingTop: "140px" }} className="text-center text-gray-400 pb-40">Memuat artikel...</div>;
  if (!article) return (
    <div style={{ paddingTop: "140px" }} className="text-center pb-40">
      <p className="text-gray-500 mb-4">Artikel tidak ditemukan.</p>
      <button onClick={() => navigate("/artikel")} className="font-semibold" style={{ color: "#198530" }}>← Kembali ke Artikel</button>
    </div>
  );

  const readMinutes = Math.max(1, Math.round((article.content || "").split(/\s+/).length / 200));

  return (
    <div data-testid="artikel-detail-page" style={{ paddingTop: "72px" }}>
      <div className="py-12 text-white" style={{ backgroundColor: "#198530" }}>
        <div className="max-w-3xl mx-auto px-4">
          <Link to="/artikel" className="inline-flex items-center gap-2 text-sm mb-5" style={{ color: "#bbf7d0" }}>
            <ArrowLeft size={16} /> Semua Artikel
          </Link>
          <span className="inline-block text-xs font-bold px-3 py-1 rounded-full mb-4" style={{ backgroundColor: "#d4af37", color: "#044712" }}>{article.category}</span>
          <h1 className="text-3xl md:text-4xl font-bold leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>{article.title}</h1>
          <div className="flex flex-wrap items-center gap-4 mt-5 text-sm" style={{ color: "#bbf7d0" }}>
            <span className="flex items-center gap-1.5"><User size={14} /> {article.author}</span>
            <span className="flex items-center gap-1.5"><Calendar size={14} /> {formatDate(article.created_at)}</span>
            <span className="flex items-center gap-1.5"><Clock size={14} /> {readMinutes} menit baca</span>
          </div>
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-4 py-10">
        {article.cover_image && (
          <img src={article.cover_image} alt={article.title} className="w-full rounded-2xl shadow-lg mb-8 object-cover" style={{ maxHeight: "420px" }} />
        )}
        {article.excerpt && (
          <p className="text-lg text-gray-600 italic leading-relaxed mb-6 pl-4" style={{ borderLeft: "4px solid #d4af37" }}>{article.excerpt}</p>
        )}
        <div className="prose max-w-none text-gray-700 leading-relaxed space-y-4">
          {(article.content || "").split("\n").filter((p) => p.trim()).map((para, idx) => (
            <p key={idx} className="text-base leading-8">{para}</p>
          ))}
        </div>
      </article>
    </div>
  );
}
